import { getAuthToken } from "../fgs/context/RequestContext";

let requestInterceptor = null;
let responseInterceptor = null;

export const useRequestInterceptor = (axiosInstance, setLoading) => {
  if (requestInterceptor || requestInterceptor === 0) {
    axiosInstance.interceptors.request.eject(requestInterceptor);
  }

  requestInterceptor = axiosInstance.interceptors.request.use(function (config) {
    setLoading(true);
    config.headers.Authorization = getAuthToken();

    return config;
  }, function (error) {
    setLoading(false);
    return Promise.reject(error);
  });
};

export const useResponseInterceptor = (axiosInstance, setLoading, setAlertContent) => {
  if (responseInterceptor || responseInterceptor === 0) {
    axiosInstance.interceptors.response.eject(responseInterceptor);
  }

  responseInterceptor = axiosInstance.interceptors.response.use(function (response) {
    setLoading(false);
    handleCreationResponses(response, setAlertContent);
    return response;
  }, function (error) {
    setLoading(false);
    handleUnauthorized(error);
    handleCreationResponses(error?.response, setAlertContent);
    return Promise.reject(error);
  });
};

function handleCreationResponses(response, setAlertContent) {
  if(response?.config?.method && ['post', 'put', 'delete'].indexOf(response?.config?.method) > -1) {
    const content = { visible: true };
    content.hasError = response.status > 399;
    content.message = response.status > 499 ? null : response.data.error;
    setAlertContent(content);
  }
}

function handleUnauthorized(error) {
  if(error.response && error.response.status === 401) {
    location.href = '/signin';
  }
}